import { Provider } from './providers.types';
import BaseProvider from './base-provider';

const SDK = {
  id: 'yt-embed-js',
  globalName: 'YT',
  url: 'https://www.youtube.com/iframe_api',
  oembed: 'https://www.youtube.com/oembed'
};

export default function Youtube(): Provider {
  let ready = false;
  const pending = [];
  const players = {}; // saving players instances here, maybe needed in the future
  const provider = BaseProvider({
    ...SDK,
    prevInit() {
      // when youtube library is ready will look for this funtion run it.
      window['onYouTubeIframeAPIReady'] = () => {
        ready = true;
        load();
      };
    }
  });

  return {
    mount
  };

  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    await provider.provideSDK();

    const videoId = getVideoId(url);
    const id = `${videoId}-${Math.random().toString(36).substring(2, 6)}`;
    const contentElement = element.querySelector('[data-content]');

    contentElement.id = id;

    pending.push({
      id,
      videoId,
      width: contentElement.clientWidth,
      height: contentElement.clientHeight,
      onReady: () => { /** noop */ },
    });

    load();
  }

  function load() {
    if (ready && pending.length > 0) {
      pending.forEach(loadPlayer);
    }
  }

  async function loadPlayer({ id, videoId, width, onReady }) {
    const YT = await provider();
    players[id] = new YT.Player(id, {
      width,
      videoId,
      host: 'https://www.youtube-nocookie.com',
      origin: window.location.origin,
      events: {
        onReady
      }
    });
  }
}

function getVideoId(url = '') {
  const urlSections = url.split('/');
  return (urlSections[urlSections.length - 1] || '').trim();
}
